import { render } from "./StepPdr.vue?vue&type=template&id=e764cb20&scoped=true"
import script from "./StepPdr.vue?vue&type=script&lang=js"
export * from "./StepPdr.vue?vue&type=script&lang=js"

import "./StepPdr.vue?vue&type=style&index=0&id=e764cb20&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e764cb20"]])

export default __exports__